export const copyManuallyDialog = {
  namespaced: true,

  state: {
    content: '',
    message: 'Unable copy to clipboard automatically. Please copy this manually:',
    isVisible: false
  },

  mutations: {
    setDialog(state, options) {
      state.content = options.content;
      state.message = options.message ?? state.message;
      state.isVisible = true;
    },
  },

  actions: {
    setDialog({ commit }, options) {
      commit('setDialog', options);
    },
  },
};